import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {NgIf} from '@angular/common';
import {LicenseModules} from '@core/modules/license/enums/license-module.enum';
import {LicenseModulesService} from '@core/modules/license/services/license-modules.service';

@Directive({
  selector: '[appHasLicenseModule]'
})
export class HasLicenseModuleDirective extends NgIf {
  @Input() set appHasLicenseModule(modules: LicenseModules[]) {
    this.ngIf = this.licenseModulesService.hasActiveModule(modules);
  }

  @Input() set appHasLicenseModuleElse(templateElse: TemplateRef<any>) {
    this.ngIfElse = templateElse;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private licenseModulesService: LicenseModulesService,
  ) {
    super(viewContainerRef, templateRef);
  }
}
